module.exports = __webpack_public_path__ + "static/img/2-2.e0fb7ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/2-2.jpg
// module id = cNW2
// module chunks = 1